// TODO enable eslint
/* eslint-disable no-nested-ternary */
import getWordByModelName from "./getWordByModelName"

export default function getSaveText(pending, dirty, modelName, isTitle) {
  if (isTitle) {
    return `Редактирование ${getWordByModelName(modelName, true)}`
  }
  return pending
    ? `Сохранение ${getWordByModelName(modelName, true)}...`
    : `Сохранить ${getWordByModelName(modelName)}`
}
